class AnimationSubs2Cols {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleSubs2Cols = this.sectionsContainer.querySelectorAll('.subs-2-cols');
		
		if (!this.$moduleSubs2Cols.length)
			return;
		
		this.$moduleSubs2ColsElements = [];
		this.$moduleSubs2Cols.forEach(module => {
			this.$moduleSubs2ColsElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleSubs2Cols.forEach((module, index) => {
		    console.log(this.$moduleSubs2ColsElements[index])
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleSubs2ColsElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		const moduleSubs2Cols = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleSubs2Cols[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleSubs2ColsElements[index], { clearProps: true });
			}
        });

        moduleSubs2Cols.addLabel('step1');
        moduleSubs2Cols.to(this.$moduleSubs2Cols[index], { opacity: 1, duration: 1 }, 'step1');
		moduleSubs2Cols.to(this.$moduleSubs2ColsElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationSubs2Cols;
